var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.main.userData !== null)?_c('CabinetInner'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }